import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import type { SupportedLanguage } from '@/i18n/supportedLanguages';
import { useUpdateOwnProfileMutation } from '@/hooks/useClientPortal';

export function LanguageSubsection() {
  const { t } = useTranslation('clients');
  const persistLanguageMutation = useUpdateOwnProfileMutation();

  function persistPreferredLanguage(language: SupportedLanguage) {
    persistLanguageMutation.mutate({ preferredLanguage: language });
  }

  return (
    <div>
      <h3 className="text-xs font-bold text-zoomuted tracking-wider uppercase mb-2">
        {t('portal.languageLabel')}
      </h3>
      <LanguageSwitcher onLanguageChange={persistPreferredLanguage} />
    </div>
  );
}
